import { render } from "./PusForCytology.vue?vue&type=template&id=62b63348&scoped=true"
import script from "./PusForCytology.vue?vue&type=script&lang=js"
export * from "./PusForCytology.vue?vue&type=script&lang=js"

import "./PusForCytology.vue?vue&type=style&index=0&id=62b63348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b63348"]])

export default __exports__